import { useState } from 'react';
import { Loader2 } from 'lucide-react';
import { useAuth } from '@/features/auth/hooks/useAuth';
import { artifactService } from '../services/artifactService';

interface ArtifactLinkProps {
  fileId: string;
  children: React.ReactNode;
}

export const ArtifactLink = ({ fileId, children }: ArtifactLinkProps) => {
  const { getAccessToken } = useAuth();
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const handleClick = async (e: React.MouseEvent) => {
    e.preventDefault();
    if (isLoading) return;
    setIsLoading(true);
    setError(null);
    try {
      const token = await getAccessToken();
      if (!token) throw new Error('Not authenticated');
      const { url } = await artifactService.getFileUrl(fileId, token);
      window.open(url, '_blank', 'noopener,noreferrer');
    } catch {
      setError('Could not load file.');
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <span className="inline-flex items-center gap-1">
      <button
        onClick={handleClick}
        disabled={isLoading}
        className="text-blue-500 underline hover:text-blue-700 disabled:opacity-60 cursor-pointer text-left"
      >
        {isLoading && <Loader2 className="inline w-3 h-3 animate-spin mr-1" />}
        {children}
      </button>
      {error && <span className="text-red-500 text-xs">{error}</span>}
    </span>
  );
};
